import { useState, useEffect } from "react";
import { Table, Form, Button, Row, Col } from 'react-bootstrap';
import{ LinkContainer } from "react-router-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import Message from "../components/Message";
import Loader from "../components/Loader";
import { FaTimes } from 'react-icons/fa';
import { useProfileMutation } from "../slices/usersApiSlice";
import { setCredentials } from "../slices/authSlice";
import { useGetMyOrdersQuery } from "../slices/ordersApiSlice";
import { formatNTD } from "../utils/pricing";

const ProfileScreen = () => {
  const [ name, setName ] = useState("");
  const [ email, setEmail ] = useState("");
  const [ mobile, setMobile ] = useState("");
  const [ password, setPassword ] = useState("");
  const [ confirmPassword, setConfirmPassword ] = useState("");

  const dispatch = useDispatch();

  const { userInfo } = useSelector((state) => state.auth);

  const [updateProfile, { isLoading:loadingUpdateProfile }] = useProfileMutation();

  const { data: orders, isLoading, error } = useGetMyOrdersQuery();

  useEffect(() => {
    if (userInfo) {
      setName(userInfo.name);
      setEmail(userInfo.email);
      setMobile(userInfo.mobile || "");
    }
  }, [userInfo, userInfo.name, userInfo.email]);

  const submitHandler = async (e) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      toast.error("兩次輸入的密碼不一致");
    } else {
      try {
        const res = await updateProfile({ _id: userInfo._id, name, email, mobile, password }).unwrap();
        dispatch(setCredentials(res));
        toast.success("個人資料已更新");
      } catch (err) {
        toast.error(err?.data?.message || err.error);
      }
    }
  };

  return (
    <Row>
      <Col>
        <h2>個人資料</h2>

        <Form onSubmit={submitHandler}>
          <Form.Group controlId="name" className="my-2">
            <Form.Label>姓名</Form.Label>
            <Form.Control
              type="name"
              placeholder="請輸入姓名"
              value={name}
              onChange={(e) => setName(e.target.value)}
            >
            </Form.Control>
          </Form.Group>
          
          <Form.Group controlId="email" className="my-2">
            <Form.Label>電子郵件</Form.Label>
            <Form.Control
              type="email"
              placeholder="請輸入電子郵件"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            >
            </Form.Control>
          </Form.Group>
          
          <Form.Group controlId="mobile" className="my-2">
            <Form.Label>手機號碼</Form.Label>
            <Form.Control
              type="tel"
              inputMode="numeric"
              autoComplete="tel"
              placeholder="0912345678（結帳時自動帶入）"
              value={mobile}
              onChange={(e) => setMobile(e.target.value)}
            >
            </Form.Control>
          </Form.Group>

          <Form.Group controlId="password" className="my-2">
            <Form.Label>密碼</Form.Label>
            <Form.Control
              type="password"
              placeholder="請輸入新密碼"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            >
            </Form.Control>
          </Form.Group>
          
          <Form.Group controlId="confirmPassword" className="my-2">
            <Form.Label>確認密碼</Form.Label>
            <Form.Control
              type="password"
              placeholder="請再次輸入新密碼"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
            >
            </Form.Control>
          </Form.Group>

          <Button type="submit" variant="primary" className="my-2">
            更新
          </Button>
          { loadingUpdateProfile && <Loader /> }
        </Form>
      </Col>
      <Col md={9}>
        <h2>我的訂單</h2>
        { isLoading ? <Loader /> : error ? (
          <Message variant="danger"> 
            { error?.data?.message || error.error} 
          </Message>) : (
          <Table striped hover responsive className="table-sm">
            <thead>
              <tr>
                <th>訂單編號</th>
                <th>日期</th>
                <th>總金額</th>
                <th>付款</th>
                <th>出貨</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              { orders.map((order) => (
                <tr key={order._id}>
                  <td>{order._id}</td>
                  <td>{order.createdAt.substring(0, 10)}</td>
                  <td>{formatNTD(order.totalPrice)}</td>
                  <td>
                    {order.isPaid ? (
                      order.paidAt.substring(0, 10)
                      ) : (
                        <FaTimes style={{ color: "red" }} />
                      )
                    }
                  </td>
                  <td>
                    <LinkContainer to={`/order/${order._id}`}>
                      <Button className="btn-sm" variant="light">查看</Button>
                    </LinkContainer>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
          )
        }
      </Col>
    </Row>
  );
};

export default ProfileScreen